var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconBtn',{attrs:{"color":_vm.color,"title":_vm.title,"icon":"mdi-thumb-up","outlined":false,"text":true,"loading":_vm.loading},on:{"click":function($event){return _vm.toggle(_vm.review)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }